<mat-toolbar class="app-header">
    <!-- Hamburger menu -->
    <button mat-icon-button [matMenuTriggerFor]="mainMenu" class="menu-btn"
            aria-label="Navigation menu" matTooltip="Menu">
        <mat-icon>menu</mat-icon>
    </button>

    <!-- ════════════════════════════════════════════════════ MAIN MENU -->
    <mat-menu #mainMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>dashboard</mat-icon> Navigation
        </div>
        <button mat-menu-item [matMenuTriggerFor]="dashboardMenu">
            <mat-icon>dashboard</mat-icon><span>Dashboard</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="schedulingMenu">
            <mat-icon>schedule</mat-icon><span>Scheduling</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="administrationMenu">
            <mat-icon>admin_panel_settings</mat-icon><span>Administration</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="reportsMenu">
            <mat-icon>summarize</mat-icon><span>Reports</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════ DASHBOARD SUBMENU -->
    <mat-menu #dashboardMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>dashboard</mat-icon> Dashboard
        </div>
        <button mat-menu-item routerLink="/dashboard/queue" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDeshboardQueue()">
            <mat-icon>queue</mat-icon><span>Queue</span>
        </button>
        <button mat-menu-item routerLink="/dashboard/running-tasks" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDeshboardRunningTasks()">
            <mat-icon>rowing</mat-icon><span>Running Tasks</span>
        </button>
        <button mat-menu-item routerLink="/dashboard/runners" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDeshboardRunners()">
            <mat-icon>directions_run</mat-icon><span>Runners</span>
        </button>
        <button mat-menu-item routerLink="/dashboard/resources-status" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDeshboardResourceStatus()">
            <mat-icon>done</mat-icon><span>Resource Status</span>
        </button>
        <button mat-menu-item routerLink="/dashboard/statistics" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDeshboardStatistics()">
            <mat-icon>show_chart</mat-icon><span>Statistics</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════ SCHEDULING SUBMENU -->
    <!-- Routes still point at /scheduling/schedules etc. — those rebadge to
         /scheduling/jobs when the Job entity ships (component rename happens
         atomically with the route rename). Today's change is label-only so
         the new vocabulary lands without breaking deep-links / bookmarks. -->
    <mat-menu #schedulingMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>schedule</mat-icon> Scheduling
        </div>
        <button mat-menu-item routerLink="/scheduling/schedules" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToViewSchedulingSchedules()">
            <mat-icon>event_repeat</mat-icon><span>Jobs</span>
        </button>
        <button mat-menu-item routerLink="/scheduling/schedule" routerLinkActive="active">
            <mat-icon>add_circle</mat-icon><span>New Job</span>
        </button>
        <button mat-menu-item routerLink="/scheduling/tasks" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToViewSechedulingTasks()">
            <mat-icon>auto_awesome_motion</mat-icon><span>Task Catalog</span>
        </button>
        <button mat-menu-item routerLink="/scheduling/user-data" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToUserDataManagement()">
            <mat-icon>file_copy</mat-icon><span>User Data</span>
        </button>
        <!-- Sources (UserDataSource list) — menu entry added when the page ships.
             Backend just shipped /userdata-source REST surface; the UI page
             that lists them is the next UI deliverable. -->
    </mat-menu>

    <!-- ═══════════════════════════════════════════ ADMINISTRATION SUBMENU -->
    <mat-menu #administrationMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>admin_panel_settings</mat-icon> Administration
        </div>
        <button mat-menu-item routerLink="/administration/users" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToViewUsers()">
            <mat-icon>supervised_user_circle</mat-icon><span>Users Management</span>
        </button>
        <button mat-menu-item routerLink="/administration/access-request-management" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToAccessRequestManagement()">
            <mat-icon>approval</mat-icon><span>Access Requests</span>
        </button>
        <button mat-menu-item routerLink="/administration/ip-blacklist" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToIpBlocklist()">
            <mat-icon>block</mat-icon><span>IP Blocklist</span>
        </button>
        <button mat-menu-item routerLink="/administration/runners" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToViewRunnersAdmin()">
            <mat-icon>memory</mat-icon><span>Runners</span>
        </button>
        <button mat-menu-item routerLink="/administration/capabilities" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToCapabilityManagement()">
            <mat-icon>extension</mat-icon><span>Capabilities</span>
        </button>
        <button mat-menu-item routerLink="/administration/reference-data" routerLinkActive="active" *ngIf="permissionChecker.hasAccessToManageReferenceData()">
            <mat-icon>category</mat-icon><span>Reference Data</span>
        </button>
        <button mat-menu-item routerLink="/administration/connectors" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToConnections()">
            <mat-icon>cable</mat-icon><span>Connections</span>
        </button>
        <button mat-menu-item routerLink="/administration/org-units" routerLinkActive="active" *ngIf="isOrgUnitsEnabled()">
            <mat-icon>account_tree</mat-icon><span>Org Units</span>
        </button>
        <button mat-menu-item routerLink="/administration/userdata-types" routerLinkActive="active"
                *ngIf="isUserDataTypesEnabled()" [disabled]="!permissionChecker.hasAccessToUserDataTypeManagement()">
            <mat-icon>schema</mat-icon><span>UserData Types</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════ REPORTS SUBMENU -->
    <mat-menu #reportsMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>summarize</mat-icon> Reports
        </div>
        <button mat-menu-item routerLink="/reports/task-execution-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToTasksExecutionReport()">
            <mat-icon>history</mat-icon><span>Task Execution Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/runners-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToRunnersReport()">
            <mat-icon>directions_run</mat-icon><span>Runners Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/tasks-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToTasksReport()">
            <mat-icon>task</mat-icon><span>Tasks Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/audit-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToAuditReport()">
            <mat-icon>track_changes</mat-icon><span>Audit Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/mail-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToMailReport()">
            <mat-icon>mail</mat-icon><span>Mail Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/mail-templates" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToMailTemplates()">
            <mat-icon>edit_note</mat-icon><span>Mail Templates</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════ HEADER RIGHT SIDE -->
    <span class="app-title">TaskSense</span>
    <span class="header-spacer"></span>

    <div class="header-actions">
        <button mat-icon-button (click)="navigate('/')" matTooltip="Home" aria-label="Home" class="header-icon-btn">
            <mat-icon>home</mat-icon>
        </button>

        <button mat-icon-button (click)="themeService.toggle()" class="header-icon-btn"
                [matTooltip]="themeService.isDark() ? 'Light mode' : 'Dark mode'"
                [attr.aria-label]="themeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode'">
            <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>

        <!-- Help dropdown — static info entries (about / support / privacy / terms). -->
        <button mat-icon-button [matMenuTriggerFor]="helpMenu"
                matTooltip="Help &amp; Info" aria-label="Help and info" class="header-icon-btn">
            <mat-icon>help_outline</mat-icon>
        </button>
        <mat-menu #helpMenu="matMenu" class="nav-menu-panel">
            <div class="menu-section-header" (click)="$event.stopPropagation()">
                <mat-icon>help_outline</mat-icon> Help &amp; Info
            </div>
            <button mat-menu-item (click)="showAbout()">
                <mat-icon>info</mat-icon><span>About</span>
            </button>
            <button mat-menu-item (click)="showSupport()">
                <mat-icon>support_agent</mat-icon><span>Support</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="showPrivacy()">
                <mat-icon>privacy_tip</mat-icon><span>Privacy Policy</span>
            </button>
            <button mat-menu-item (click)="showTerms()">
                <mat-icon>gavel</mat-icon><span>Terms of Service</span>
            </button>
        </mat-menu>

        <div class="header-separator"></div>

        <!-- User dropdown — username only, no role line (TaskSense uses authorities not roles) -->
        <button mat-button [matMenuTriggerFor]="userContextMenu" class="user-menu-btn">
            <span class="user-avatar">{{ getUserInitials() }}</span>
            <span class="user-name">{{ user.username || appConfigService.getUserId() }}</span>
        </button>
        <mat-menu #userContextMenu="matMenu" class="nav-menu-panel">
            <div class="menu-section-header" (click)="$event.stopPropagation()">
                <span class="user-avatar user-avatar-menu">{{ getUserInitials() }}</span>
                {{ user.username || appConfigService.getUserId() }}
            </div>
            <button mat-menu-item routerLink="/settings/profile">
                <mat-icon>person</mat-icon>
                <span>Edit Profile</span>
            </button>
            <button mat-menu-item (click)="onChangePassword()">
                <mat-icon>lock</mat-icon>
                <span>Change Password</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onLogout()" class="menu-item-logout">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>
</mat-toolbar>
